import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader } from '@ngx-translate/core';
import { dasherize, underscore } from 'inflection';
import { from, Observable } from 'rxjs';

export function toKey(keyish: string): string {
  return dasherize(underscore(keyish));
}

export class LazyTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return from(import(`../../i18n/${lang}.json`));
  }
}

export class DefaultMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (params.interpolateParams && 'defaultValue' in params.interpolateParams) {
      return params.interpolateParams['defaultValue'];
    }
    return params.key;
  }
}
